import { Api } from "../api/Api";
export const blacklist = () => {
  const getBlacklist = async () => {
    const response = await Api.get("api/v1/blacklist", {});
    return response;
  };
  return { getBlacklist };
};
